/* eslint-disable no-unused-vars */
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './featured-products.html';
import { ProductStatusService, ShopContextService, OrderType, Product, ProductStatus } from '@nuskin/ns-shop';
import { ProductDataService } from '@nuskin/ns-product'
import { MySiteRestService } from '@nuskin/my-site-api';
import { UserService } from '@nuskin/ns-account';
import { MySiteApp, OverwritePaperRadioButtonStyles, PREDICTIVE_SEARCH_LIMIT } from '../../my-site-app'
import { ConfigService, nuskin, equinoxLocalStorage } from '@nuskin/ns-util';
import { MySiteProductDetails } from './my-site-product-details/my-site-product-details.js'
import { getConfiguration } from "@nuskin/configuration-sdk";



/**
 * @customElement
 * @polymer
 */
export class FeaturedProducts extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.data = {} //api data

        this.eventsToListenTo = [
            'value-changed',
            'valid-changed',
            'invalid-changed'
        ];

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();

        this.aboutProductsLength = 0;
        this.maxChar = 125;

        this.featured = this.content.featuredProductsFormFeatured;

        this.nsSearchTranslations = {
            desktopPlaceholder: this.content.featuredProductsFormSearchPlaceholder,
            mobilePlaceholder: this.content.featuredProductsFormSearchPlaceholder,
            noResults: this.content.featuredProductsFormSearchNoResults
        }
        console.log(MySiteProductDetails.is + 'do not go away, component!')
    }

    static get properties() {
        return {
            products: {
                type: Array,
                value: []
            },
            useDefaultList: {
                type: Boolean,
                observer: '_handleUseDefaultOption',
                value: true
            },
            productsLoading: {
                type: Boolean,
                observer: '_handleProductsLoading'
            }
        }
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'featured-products';
    }

    ready() {
        super.ready();
        this.getFormFields();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.parentNode.formChanged);
                field.addEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
        this.overwritePaperRadioButtonStyles();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('current-market-changed', e => {
            this.currentMarket = e.detail.value;
            this.setPredictiveSearch();
        })
        this.mySite.addEventListener('current-language-changed', e => {
            this.currentLanaguage = e.detail.value;
            this.setPredictiveSearch();
        })
    }

    connectedCallback() {
        super.connectedCallback();
        this.mySite.addEventListener('my-site-data-changed', this.getMySiteData.bind(this));
        this.mySite.addEventListener('on-menu-item-click', this._handleFormShow.bind(this));
        this.mySite.addEventListener('common-strings-changed', this._subscribeToCommonStrings.bind(this));

        this.$.sortable.addEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.addEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
        this.$.sortable.$.itemList.addEventListener('rendered-item-count-changed', this._handleFeatured.bind(this));
        this.$.aboutProducts.addEventListener('value-changed', this._handleAboutProductsChange.bind(this))
        this.$.productSearch.addEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this.mySite.removeEventListener('my-site-data-changed', this.getMySiteData.bind(this));
        this.mySite.removeEventListener('on-menu-item-click', this._handleFormShow.bind(this));

        this.$.sortable.$.itemList.removeEventListener('rendered-item-count-changed', this._handleFeatured.bind(this));
        this.$.sortable.removeEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.removeEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
        this.$.aboutProducts.removeEventListener('value-changed', this._handleAboutProductsChange.bind(this))
        this.$.productSearch.removeEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
        this.mySite.removeEventListener('current-market-changed', e => {
            this.currentMarket = e.detail.value
        })
        this.mySite.removeEventListener('current-language-changed', e => {
            this.currentLanaguage = e.detail.value
        })
    }

    setPredictiveSearch() {
        let predictiveOrderTypes = [OrderType.ORDER];
        const marketConfig = ConfigService.getMarketConfig();
        if (!marketConfig.storefront.mySiteHideAdr) {
            predictiveOrderTypes = [OrderType.ADR, OrderType.ORDER];
        }
        this.set('searchOptions', {
            market: this.currentMarket,
            language: this.currentLanaguage,
            orderTypes: predictiveOrderTypes,
            predictiveLimit: PREDICTIVE_SEARCH_LIMIT
        });
    }

    _handleProductsLoading(newVal) {
        if (newVal) {
            this.timeout = this.timeout || setTimeout(() => {
                this.mySite.iframeLoading = true;
            }, 2000);

            this.$.defaultOption.setAttribute('disabled', true);
            this.$.customOption.setAttribute('disabled', true);
        } else {
            this.$.defaultOption.removeAttribute('disabled', true);
            this.$.customOption.removeAttribute('disabled', true);

            clearTimeout(this.timeout);
            this.mySite.iframeLoading = false;
            this.timeout = null;
        }
    }

    overwritePaperRadioButtonStyles() {
        OverwritePaperRadioButtonStyles(this.$.defaultOption);
        OverwritePaperRadioButtonStyles(this.$.customOption);
    }

    _handleDefaultClick() {
        this.useDefaultList = true;
        // has to be here
        this.$.defaultOption.checked = true;
        this.$.customOption.checked = false;
        this.parentNode.updateAndNotify(this.useDefaultList, true, false, 'showDefaultProducts');
    }

    _handleCustomClick() {
        this.useDefaultList = false;
        // has to be here
        this.$.defaultOption.checked = false;
        this.$.customOption.checked = true;
        this.parentNode.updateAndNotify(this.useDefaultList, true, false, 'showDefaultProducts');
    }

    async _handleUseDefaultOption(newVal, oldVal) {

        this.$.defaultOption.checked = newVal;
        this.$.customOption.checked = !newVal;

        this.$.chooseDefault.className = newVal ? '' : 'hidden';
        this.$.chooseCustom.className = !newVal ? '' : 'hidden';

        if (!this.mySite) return;

        if (!newVal) {
            this.$.sortable.resizeItemsContainer();
            let prods = this.mySite.mySiteData.storefront[this.subdomain][this.mySite.currentMarket].products;
            if (!prods || !prods.length) {
                let products = await MySiteRestService.getMarketFeaturedProducts()
                this.parentElement.updateAndNotify(products.map(item => item.sku), true, false, 'products', true)
            }
        } else { // pull products from AEM
            let prds = await MySiteRestService.getMarketFeaturedProducts()
            this.parentElement.updateAndNotify(prds.map(item => item.sku), true, false, 'products', true);
            this.parentElement.updateAndNotify(this.mySite.mySiteHomeTranslations.tdc_featuredProductsDescription, true, true, 'aboutProducts');
        }

        if (oldVal !== undefined) {
            this.parentElement.formTouched();
            this.parentElement.setFormValidity(true);
        }
    }

    _handleOrderChange(e) {
        this.set('products', e.detail.reorderedList);

        this.parentNode.updateAndNotify(e.detail.reorderedList.map(item => item.sku), true, false, 'products', true);

        this.parentElement.formTouched();

        if (this.useDefaultList)
            this.parentElement.setFormValidity(true);
    }

    _handleItemRemoved(e) {
        let updatedList = this.products.slice();
        updatedList.splice(e.detail.index * 1, 1);
        this.set('products', updatedList);

        this.parentNode.updateAndNotify(updatedList.map(item => item.sku), true, false, 'products')

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    _subscribeToCommonStrings(e) {
        let data = e.detail.value
        this.set('fieldRequired', data.fieldRequired)
    }

    _handleFormShow(e) {
        if (e.detail.item === FeaturedProducts.is) {
            this.set('searchedProducts', [])
            this.$.sortable.resizeItemsContainer();
            this.getMySiteData();
        }
    }

    _handleAboutProductsChange(e) {
        this.aboutProductsLength = e.target.value.length || 0;

        this.parentNode.updateAndNotify(e.target.value, true, true, 'aboutProducts')

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    async getMySiteData() {
        if (this.mySite.currentForm !== FeaturedProducts.is) return;
        this.set('data', this.mySite.mySiteData);

        if (!this.mySite.mySiteData.storefront) return;

        this.set('subdomain', Object.keys(this.mySite.mySiteData.storefront)[0]);

        this.useDefaultList = !!this.data.storefront[this.subdomain][this.mySite.currentMarket].showDefaultProducts;

        this.aboutProducts = this.getAboutProducts();
        this.aboutProductsLength = this.aboutProducts ? this.aboutProducts.length : 0;
        let skus = this.getFeaturedProductsSkus();

        if (!skus.length) return;

        this.set('productsLoading', true);
        let products = await this.getProductObjects(skus);
        this.set('products', products);
        this.set('productsLoading', false);

        // this.parentNode.formChanged();

        if (this.useDefaultList || (this.aboutProductsLength && this.aboutProducts))
            this.parentElement.setFormValidity(true);
    }

    async getProductObjects(skus) {
        let products = [];
        if (!this.mySite) return products;
        if (!skus) {
            let prods = await MySiteRestService.getMarketFeaturedProducts();
            skus = prods.map(item => item.sku) || []
        }
        try {
            for (let i = 0; i < skus.length; i++) {
                let sku = skus[i]
                const prodSvc = await ProductDataService.getProductData(sku);
                if (prodSvc.products) {
                    if (prodSvc.products[0].isBase()) {
                        products.push({
                            sku: prodSvc.products[0].variants[sku].sku,
                            itemName: prodSvc.products[0].variants[sku].title,
                            priceMap: prodSvc.products[0].variants[sku].priceMap,
                            psv: prodSvc.products[0].variants[sku].pv,
                            img: (prodSvc.products[0].variants[sku].thumbnail.includes('https')) ? prodSvc.products[0].variants[sku].thumbnail : nuskin.configuration.siteUrl + prodSvc.products[0].variants[sku].thumbnail
                        })
                    } else {
                        const thumbnail = prodSvc.products[0].thumbnail ? prodSvc.products[0].thumbnail : ''
                        products.push({
                            sku: sku,
                            itemName: prodSvc.products[0].title || "Product not found",
                            priceMap: prodSvc.products[0].priceMap || {},
                            psv: prodSvc.products[0].pv || 0,
                            img: (thumbnail.includes('https')) ? thumbnail : nuskin.configuration.siteUrl + prodSvc.products[0].thumbnail
                        })
                    }
                }
            }
        } catch (error) {
            console.log({ 'context': 'FeaturedProducts.getProductObjects', 'error': error });
        }

        return products;
    }

    async _handlePredictiveSearch(e) {
        let res = e.detail;
        const equinoxMarketConfig = (await getConfiguration(["Equinox_Markets"]))
            .Equinox_Markets;
        const isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && equinoxMarketConfig.active;
        let featuredProducts = res;

        //filter featured products search typehead
        //increased latency due to results filtering if market is equinox enabled
        if (isEquinoxEnabled && (res && res.length)) {

            featuredProducts = await Promise.all(
                res.map(async (item) => {
                    try {
                        const featuredProductData = await ProductDataService.getProductData(item.sku);

                        return {
                            ...item,
                            status: (featuredProductData.products && featuredProductData.products.length > 0 && featuredProductData.products[0].status) ? featuredProductData.products[0].status : ProductStatus.NOT_RELEASED_FOR_SALE
                        };
                    } catch (e) {
                        console.log(e);
                    }

                    return { ...item, status: ProductStatus.NOT_RELEASED_FOR_SALE };
                })
            );

            featuredProducts = featuredProducts.filter(product => {
                return product.status === ProductStatus.ReleasedForSale;
            });

        }

        this.searchedProducts = featuredProducts && featuredProducts.length ? featuredProducts : [{}]; // empty object is added to indicate 'No Results'
    }

    async _onSlottedSelect(e) {
        let item = JSON.parse(e.currentTarget.dataset.item);

        this.$.productSearch.blur();
        const equinoxMarketConfig = (await getConfiguration(["Equinox_Markets"]))
            .Equinox_Markets;
        const isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && equinoxMarketConfig.active;

        if (this.products.find(prod => item.sku === prod.sku)) return;
        let prodSvc
        try {
            prodSvc = await ProductDataService.getProductData(item.sku);
        } catch (err) { console.log(err) }
        let products = this.products.slice();


        if (isEquinoxEnabled) {
            const productsSvc = prodSvc.products
                .map((product) => ({
                    sku: product.sku,
                    itemName: product.title,
                    priceMap: product.priceMap,
                    psv: product.pv,
                    img: (product.thumbnail.includes('https')) ? product.thumbnail : nuskin.configuration.siteUrl + product.thumbnail
                }));
            products.push(productsSvc[0]);
            products.flat();
        } else {
            if (prodSvc.products[0].isBase() && prodSvc.products[0].sku === item.sku) {
                products.push({
                    sku: prodSvc.products[0].sku,
                    itemName: prodSvc.products[0].title,
                    priceMap: prodSvc.products[0].priceMap,
                    psv: prodSvc.products[0].pv,
                    img: (prodSvc.products[0].thumbnail.includes('https')) ? prodSvc.products[0].thumbnail : nuskin.configuration.siteUrl + prodSvc.products[0].thumbnail
                });

            } else if (prodSvc.products[0].isBase() && prodSvc.products[0].sku !== item.sku) {
                products.push({
                    sku: prodSvc.products[0].variants[item.sku].sku,
                    itemName: prodSvc.products[0].variants[item.sku].title,
                    priceMap: prodSvc.products[0].variants[item.sku].priceMap,
                    psv: prodSvc.products[0].variants[item.sku].pv,
                    img: (prodSvc.products[0].variants[item.sku].thumbnail.includes('https')) ? prodSvc.products[0].variants[item.sku].thumbnail : nuskin.configuration.siteUrl + prodSvc.products[0].variants[item.sku].thumbnail
                });
            } else {
                products.push({
                    sku: prodSvc.products[0].sku,
                    itemName: prodSvc.products[0].title,
                    priceMap: prodSvc.products[0].priceMap,
                    psv: prodSvc.pv,
                    img: (prodSvc.products[0].thumbnail.includes('https')) ? prodSvc.products[0].thumbnail : nuskin.configuration.siteUrl + prodSvc.products[0].thumbnail
                });
            }

        }
        this.set('products', products);

        this.parentNode.updateAndNotify(products.map(item => item.sku), true, false, 'products')

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    _handleFeatured() {
        let items = Array.prototype.slice.call(this.$.sortable.$.items.querySelectorAll('.actions'));
        items.forEach((item, index) => {
            let header = item.querySelector('.head-title');
            if (index < 3) {
                if (header.innerHTML.indexOf(this.featured) === -1)
                    header.innerHTML += ' - ' + this.featured;
            } else {
                header.innerHTML = header.innerHTML.split(this.featured).join('');
            }
        });
    }

    removeAllProducts() {
        this.set('products', []);

        this.parentNode.updateAndNotify(this.products, true, false, 'products');

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    async addBestSellingProducts() {
        this.parentElement.setFormValidity(false);

        let featuredProducts = await MySiteRestService.getMarketFeaturedProducts();
        let skus = featuredProducts.map(item => item.sku);

        this.parentNode.updateAndNotify(skus, true, false, 'products');

        let productsStatuses = await ProductStatusService.getProductStatus(skus, this.mySite.currentMarket);

        let products = [];
        // TODO: do some loading indicator, since getting products (if many) take up some time
        featuredProducts.forEach(item => {
            let product = new Product(item);
            let status = productsStatuses.find(prod => prod.SKU === item.sku);
            let priceType = ShopContextService.getPriceType(false, UserService.getUser());
            product.setMarketAttributes(status);
            product.addPricingFromStatus(status, priceType);

            products.push({
                sku: item.sku,
                itemName: item.title,
                priceMap: product.priceMap,
                psv: product.pv,
                img: nuskin.configuration.siteUrl + item.path
            });
        });
        console.log('addBestSellingProducts:' + products)

        this.set('products', products);

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    isEmptyIndicator(item) {
        return Object.keys(item).length === 0;
    }

    getAboutProducts() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];

            // DTS-266
            let aboutProds;
            if (subdomain)
                aboutProds = this.$.aboutProducts.focused
                    ? this.data.storefront[subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].aboutProducts
                    : this.data.storefront[subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].aboutProducts || this.mySite.mySiteHomeTranslations.tdc_featuredProductsDescription

            return aboutProds;
        }
    }

    getFeaturedProductsSkus() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];
            let list = this.data.storefront[subdomain][this.mySite.currentMarket].products || [];

            return subdomain
                ? list
                : []
        }
    }

    save() {
        let that = this;
        return function () {
            let skus = that.products.map(item => item.sku);
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: FeaturedProducts.is,
                        changed: {
                            skus,
                            aboutProducts: that.$.aboutProducts.value
                        }
                    }
                });
            } catch (err) { console.log(err) }
            return MySiteRestService.saveFeaturedProducts(skus, that.$.aboutProducts.value || '', that.mySite.currentMarket, that.mySite.currentLanguage, that.useDefaultList);
        }
    }

    getFormFields() {
        this.formFields = [
            this.$.aboutProducts,
            this.$.sortable
        ];
    }

}

window.customElements.define(FeaturedProducts.is, FeaturedProducts);
